import React from "react";
import { Link, useLocation } from "react-router-dom";

const BottomNav = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <div className="fixed bottom-4 left-0 right-0 flex justify-center">
      
      {/* 👇 MATCH your app width */}
      <div className="w-full max-w-[430px] px-3">
        
        <nav className="flex justify-around px-4 py-3 rounded-2xl 
          bg-white/20 backdrop-blur-md 
          border border-white/30 shadow-lg">

          <Link
            to="/"
            className={`px-3 py-1 rounded-lg ${
              isActive("/") 
                ? "bg-white/40 font-semibold text-black" 
                : "text-gray-700"
            }`}
          >
            Home
          </Link>

          <Link
            to="/tracking"
            className={`px-3 py-1 rounded-lg ${
              isActive("/tracking") 
                ? "bg-white/40 font-semibold text-black" 
                : "text-gray-700"
            }`}
          >
            Track
          </Link>

          <Link
            to="/about"
            className={`px-3 py-1 rounded-lg ${
              isActive("/about") 
                ? "bg-white/40 font-semibold text-black" 
                : "text-gray-700"
            }`}
          >
            About
          </Link>

        </nav>

      </div>
    </div>
  );
};

export default BottomNav;